<script>
export default {
  props: {
    currentQuestion: Object,    
  },

  data() {
    return {
      BACKEND_URL: process.env.VUE_APP_BACKEND_URL,
      BACKEND_URL_VERSION: process.env.VUE_APP_BACKEND_URL_VERSION,
      selectedIndex : null,
    };
  },
};
</script>

<template>
  <div v-if="currentQuestion" class="mym-question-body">
    <!-- NUMBER -->
    <div class="mym-question-navigation">
      <div class="mym-question-section">
        <div class="mb-2">
          <div>
            <h4>Petunjuk Benar Salah</h4>
          </div>

          <div>
            <p>
              Silahkan pilih salah satu jawaban dengan klik pada pilihan jawaban
              yang tersedia.
            </p>
          </div>

          <p>Klik "preview" untuk menampilkan gambar</p>
        </div>

        <div class="mb-3">
          <b>Contoh Soal</b>
          <p>{{ currentQuestion.soal_text }}</p>
        </div>

        <div class="mb-3">
          <img
            v-if="currentQuestion?.soal_image"
            :src="BACKEND_URL + currentQuestion?.soal_image"
            class="mym-question-image"
          />
          <div class="mym-question-text">
            {{ currentQuestion?.pertanyaan }}
          </div>
        </div>
      </div>
    </div>

    <!-- ================= OPTIONS SECTION ================= -->
    <div class="mym-options-section">
      <div
        class="mym-options boolean-mode"
      >
        <div
          v-for="(jawaban, i) in currentQuestion?.jawaban"
          :key="i"
          class="mym-option-card boolean-card"
          :class="{ active: selectedIndex === i }"
          @click="selectedIndex = i"
        >
          <div class="boolean-content">
            <div class="boolean-icon">
              <span v-if="selectedIndex === i" class="text-primary icon-i">
                <i class="fas fa-check-circle fa-fw"></i>
              </span>
              <span v-else>
                <i
                  v-if="jawaban?.kode_jawaban == 'A'"
                  class="fa fa-check icon-i fa-fw"
                ></i>
                <i v-else class="fa fa-times icon-i fa-fw"></i>
              </span>
            </div>

            <div class="boolean-text">
              {{ jawaban?.jawaban }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>